
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.299 13.31L.619 7.632a.892.892 0 010-1.262l5.68-5.68A.892.892 0 117.56 1.951L3.405 6.107H12.8v1.785H3.405L7.56 12.05a.893.893 0 01-1.262 1.262z","fill":"#fff"}})])
          )
        }
      }
    